import { render, staticRenderFns } from "./HeaderPageDerek.vue?vue&type=template&id=374b066a&"
import script from "./HeaderPageDerek.vue?vue&type=script&lang=js&"
export * from "./HeaderPageDerek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports